import { BaseService } from '@colescba/services'
import { authHeaders } from '@/util/auth.util'
import { TIPOS_ACOMPANANTE, TIPOS_SOLICITUD, formatDate } from '@/model'

import moment from 'moment'

class AutorizacionesService extends BaseService {
  /**
   * Crea una nueva solicitud de tipo autorizacion
   *
   * @param {import('@/model/autorizacion').Autorizacion} autorizacion
   */
  async guardar(solicitud, tipo) {
    var solicitudRequest;
    if(tipo === TIPOS_SOLICITUD.REVOCATORIA_TOTAL){
        solicitudRequest = this.toRevocatoriaTotalRequest(solicitud)
    }else{
      solicitudRequest = this.toAutorizacionRequest(solicitud)
    } 
      //const response = await this.http.post(`/solicitudes`, solicitud, { headers: authHeaders(" 20145502404")})
    const response = await this.http.post(`/solicitudes`, solicitudRequest)
    return response.data
  }

 

  /**
   * Crea una nueva solicitud de tipo modificatoria, que modifica a la solicitud dada
   *
   * @param {import('@/model/autorizacion').Autorizacion} modificatoria
   * @param {Number|Object} solicitud
   */
  async modificatoria(modificatoria, solicitud) {
    const solicitudId = solicitud.solicitudId || solicitud
    const solicitudModificatoria = this.toModificatoriaRequest(modificatoria)
    const response = await this.http.put(`/solicitudes/${solicitudId}`, solicitudModificatoria)
    //const response = await this.http.put(`/solicitudes/${solicitudId}`, solicitudModificatoria, { headers: authHeaders("20145502404")})
    return response.data
  }

  async generarArchivoSolicitud(solicitudId) {
    //const response = await this.http.post(`/solicitudes/archivo`, solicitudRequest, { headers: authHeaders("20145502404")})
    const response = await this.http.post(`/solicitudes/`+solicitudId+`/archivo`)
    return response.data
  }

  async getSolicitud(solicitudId){
    const response =  await this.http.get(`/solicitudes/${solicitudId}`)
    return response.data
  }

  async presentar(solicitudId,archivoId, hash ) {
   const presentacionRequest = {
      archivoId :archivoId,
      hash: hash
    }
    const response = await this.http.post(`/solicitudes/${solicitudId}/presentaciones`, presentacionRequest)
    return response.data
  }

  // BuildJson

  toAutorizacionRequest(solicitud) {
    const menor = {
      nombre: solicitud.menor.primerNombre,
      apellido: solicitud.menor.primerApellido,
      domicilio: solicitud.menor.domicilio,
      nacionalidad: solicitud.menor.nacionalidad.id,
      otros_nombres: solicitud.menor.otrosNombres,
      segundo_apellido: solicitud.menor.segundoApellido,
      tipo_documento: solicitud.menor.tipoDocumento.id,
      numero_documento: solicitud.menor.numeroDocumento,
      fecha_nacimiento: formatDate(solicitud.menor.fechaNacimiento.date),
      sexo: solicitud.menor.sexo.id,
      emisor_documento: solicitud.menor.emisorDocumento.id,
      acompanante_tipo: solicitud.menor.tipoAcompanante.id,
      // estos los van vacios porque se debe completar, antes de enviar a DNM, con el valor de la solicitudId luego de grabar en la bd
      numero_tramite_migraciones: '',
      fecha_tramite_migraciones: '',
    }

    const autorizantes = solicitud.autorizantes.map(autorizante => {
      return {
        nombre: autorizante.primerNombre,
        apellido: autorizante.primerApellido,
        segundo_apellido: autorizante.segundoApellido,
        otros_nombres: autorizante.otrosNombres,
        sexo: autorizante.sexo.id,
        tipo_documento: autorizante.tipoDocumento.id,
        numero_documento: autorizante.numeroDocumento,
        fecha_nacimiento: formatDate(autorizante.fechaNacimiento.date),
        domicilio: autorizante.domicilio,
        telefono: autorizante.telefono.text,
        nacionalidad: autorizante.nacionalidad.id,
        vinculo: autorizante.vinculo.id,
        caracter_autorizante: autorizante.caracterAutorizante.id,
        emisor_documento: autorizante.emisorDocumento.id,
        requiere_autorizacion_adicional_de: autorizante.autorizacionAdicional,
      }
    })

    let acompaniantes = []
    if (solicitud.acompaniantes) {
      acompaniantes = solicitud.acompaniantes.map(acompanante => {
        return {
          nombre: acompanante.primerNombre,
          apellido: acompanante.primerApellido,
          segundo_apellido: acompanante.segundoApellido,
          otros_nombres: acompanante.otrosNombres,
          tipo_documento: acompanante.tipoDocumento.id,
          tipo_acompaniante: acompanante.progenitor
            ? TIPOS_ACOMPANANTE.PROGENITOR
            : TIPOS_ACOMPANANTE.TERCERO,
          numero_documento: acompanante.numeroDocumento,
          progenitor: acompanante.progenitor,
        }
      })
    }

    const paises_autorizados = solicitud.actuacion.paisesAutorizados.map(pais => pais.id)
    const fecha_vigencia_desde = moment(solicitud.actuacion.vigencia.fechaDesde)
    const fecha_vigencia_hasta = moment(solicitud.actuacion.vigencia.fechaHasta)
    const fecha_del_instrumento = moment(solicitud.actuacion.fechaInstrumento)

    const solicitudRequest = {
      tipo: TIPOS_SOLICITUD.AUTORIZACION,
      es_para_cualquier_pais: solicitud.actuacion.autorizaCualquierPais,
      esta_vigencia_hasta_mayoria_edad: solicitud.actuacion.vigenciaHastaMayoriaEdad,
      fecha_vigencia_desde,
      fecha_vigencia_hasta,
      foja_tipo: solicitud.actuacion.tipoFoja.id,
      foja_serie: solicitud.actuacion.serieFoja,
      foja_nro: solicitud.actuacion.nroFoja,
      tipo_instrumento: solicitud.actuacion.tipoInstrumento.id,
      fecha_del_instrumento,
      menores: [menor],
      autorizantes,
      acompaniantes,
      paises_autorizados,
    }

    
    return solicitudRequest
  }

  toRevocatoriaTotalRequest(revocatoria) {
    const menor = {
      nombre: revocatoria.menor.primerNombre,
      apellido: revocatoria.menor.primerApellido,
      domicilio: revocatoria.menor.domicilio,
      nacionalidad: revocatoria.menor.nacionalidad.id,
      otros_nombres: revocatoria.menor.otrosNombres,
      segundo_apellido: revocatoria.menor.segundoApellido,
      tipo_documento: revocatoria.menor.tipoDocumento.id,
      numero_documento: revocatoria.menor.numeroDocumento,
      fecha_nacimiento: formatDate(revocatoria.menor.fechaNacimiento.date),
      sexo: revocatoria.menor.sexo.id,
      emisor_documento: revocatoria.menor.emisorDocumento.id,
      //acompanante_tipo: revocatoria.menor.tipoAcompanante.id,
      // estos los van vacios porque se debe completar, antes de enviar a DNM, con el valor de la solicitudId luego de grabar en la bd
      numero_tramite_migraciones: '',
      fecha_tramite_migraciones: '',
    }

    const autorizantes = revocatoria.autorizantes.map(autorizante => {
      return {
        nombre: autorizante.primerNombre,
        apellido: autorizante.primerApellido,
        segundo_apellido: autorizante.segundoApellido,
        otros_nombres: autorizante.otrosNombres,
        sexo: autorizante.sexo.id,
        tipo_documento: autorizante.tipoDocumento.id,
        numero_documento: autorizante.numeroDocumento,
        fecha_nacimiento: formatDate(autorizante.fechaNacimiento.date),
        domicilio: autorizante.domicilio,
        telefono: autorizante.telefono.text,
        nacionalidad: autorizante.nacionalidad.id,
        vinculo: autorizante.vinculo.id,
        caracter_autorizante: autorizante.caracterAutorizante.id,
        emisor_documento: autorizante.emisorDocumento.id,
        requiere_autorizacion_adicional_de: autorizante.autorizacionAdicional,
      }
    })

    //const paises_autorizados = revocatoria.actuacion.paisesAutorizados.map(pais => pais.id)
    const fecha_vigencia_desde = moment(revocatoria.actuacion.vigencia.fechaDesde)
    const fecha_vigencia_hasta = moment(revocatoria.actuacion.vigencia.fechaHasta)
    const fecha_del_instrumento = moment(revocatoria.actuacion.fechaInstrumento)

    const solicitud = {
      tipo: TIPOS_SOLICITUD.REVOCATORIA_TOTAL,
      es_para_cualquier_pais: revocatoria.actuacion.autorizaCualquierPais,
      esta_vigencia_hasta_mayoria_edad: revocatoria.actuacion.vigenciaHastaMayoriaEdad,
      fecha_vigencia_desde,
      fecha_vigencia_hasta,
      foja_tipo: revocatoria.actuacion.tipoFoja.id,
      foja_serie: revocatoria.actuacion.serieFoja,
      foja_nro: revocatoria.actuacion.nroFoja,
      tipo_instrumento: revocatoria.actuacion.tipoInstrumento.id,
      fecha_del_instrumento,
      menores: [menor],
      autorizantes,
      correos_notificacion: revocatoria.actuacion.emails,
      correo_notario: revocatoria.actuacion.emailNotario,
      // acompaniantes,
      // paises_autorizados,
    }

    
    return solicitud
  }


  
  toModificatoriaRequest(modificatoria) {
    const menor = {
      nombre: modificatoria.menor.primerNombre,
      apellido: modificatoria.menor.primerApellido,
      domicilio: modificatoria.menor.domicilio,
      nacionalidad: modificatoria.menor.nacionalidad.id,
      otros_nombres: modificatoria.menor.otrosNombres,
      segundo_apellido: modificatoria.menor.segundoApellido,
      tipo_documento: modificatoria.menor.tipoDocumento.id,
      numero_documento: modificatoria.menor.numeroDocumento,
      fecha_nacimiento: formatDate(modificatoria.menor.fechaNacimiento.date),
      sexo: modificatoria.menor.sexo.id,
      emisor_documento: modificatoria.menor.emisorDocumento.id,
      acompanante_tipo: modificatoria.menor.tipoAcompanante.id,
      numero_tramite_migraciones: modificatoria.menor.numeroTramiteMigraciones,
      fecha_tramite_migraciones: modificatoria.menor.fechaTramiteMigraciones,
    }

    const autorizantes = modificatoria.autorizantes.map(autorizante => {
      const fechaNacimiento = autorizante.fechaNacimiento.date || autorizante.fechaNacimiento
      const telefono = autorizante.telefono.text || autorizante.telefono

      return {
        nombre: autorizante.primerNombre,
        apellido: autorizante.primerApellido,
        segundo_apellido: autorizante.segundoApellido,
        otros_nombres: autorizante.otrosNombres,
        sexo: autorizante.sexo.id,
        tipo_documento: autorizante.tipoDocumento.id,
        numero_documento: autorizante.numeroDocumento,
        fecha_nacimiento: formatDate(fechaNacimiento),
        domicilio: autorizante.domicilio,
        telefono,
        nacionalidad: autorizante.nacionalidad.id,
        vinculo: autorizante.vinculo.id,
        caracter_autorizante: autorizante.caracterAutorizante.id,
        emisor_documento: autorizante.emisorDocumento.id,
        requiere_autorizacion_adicional_de: autorizante.autorizacionAdicional,
      }
    })

    let acompaniantes = []
    if (modificatoria.acompaniantes) {
      acompaniantes = modificatoria.acompaniantes.map(acompanante => {
        return {
          nombre: acompanante.primerNombre,
          apellido: acompanante.primerApellido,
          segundo_apellido: acompanante.segundoApellido,
          otros_nombres: acompanante.otrosNombres,
          tipo_documento: acompanante.tipoDocumento.id,
          tipo_acompaniante: acompanante.progenitor
            ? TIPOS_ACOMPANANTE.PROGENITOR
            : TIPOS_ACOMPANANTE.TERCERO,
          numero_documento: acompanante.numeroDocumento,
          progenitor: acompanante.progenitor,
        }
      })
    }

    const paises_autorizados = modificatoria.actuacion.paisesAutorizados.map(pais => pais.id)
    const fecha_vigencia_desde = moment(modificatoria.actuacion.vigencia.fechaDesde)
    const fecha_vigencia_hasta = moment(modificatoria.actuacion.vigencia.fechaHasta)
    const fecha_del_instrumento = moment(modificatoria.actuacion.fechaInstrumento)
    const tipo_instrumento =
      modificatoria.actuacion.tipoInstrumento && modificatoria.actuacion.tipoInstrumento.id

    const solicitud = {
      tipo: TIPOS_SOLICITUD.AUTORIZACION,
      es_para_cualquier_pais: modificatoria.actuacion.autorizaCualquierPais,
      esta_vigencia_hasta_mayoria_edad: modificatoria.actuacion.vigenciaHastaMayoriaEdad,
      fecha_vigencia_desde,
      fecha_vigencia_hasta,
      foja_tipo: modificatoria.actuacion.tipoFoja.id,
      foja_serie: modificatoria.actuacion.serieFoja,
      foja_nro: modificatoria.actuacion.nroFoja,
      tipo_instrumento,
      fecha_del_instrumento,
      menores: [menor],
      autorizantes,
      acompaniantes,
      paises_autorizados,
    }


    return solicitud
  }
}
export { AutorizacionesService }
